import React from 'react';
import { useParams } from 'react-router-dom';
export function Collection() {
  const {
    category
  } = useParams();
  const title = category?.replace(/-/g, ' ') || 'Collection';
  const collectionImages = ['https://cdn.magicpatterns.com/uploads/jEej3XExu4hp2w3M59neD7/image.png', 'https://cdn.magicpatterns.com/uploads/pyPQ371b8FAGqP4T9JAg1g/image.png', 'https://cdn.magicpatterns.com/uploads/d353YWp21zZqnC3Pek7CAu/image.png', 'https://cdn.magicpatterns.com/uploads/bNzipinq9iBsE8CPGtTcf7/image.png', 'https://cdn.magicpatterns.com/uploads/hKWnidCpo3bKaJQkESyfZm/image.png'];
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-268">
      <div className="max-w-[1800px] mx-auto" data-id="element-269">
        <header className="mb-20 text-center" data-id="element-270">
          <span className="text-[10px] font-display uppercase tracking-[0.5em] mb-4 block text-black/40" data-id="element-271">
            Shop
          </span>
          <h1 className="text-4xl md:text-6xl font-display font-bold tracking-[0.2em] uppercase mb-6" data-id="element-272">
            {title}
          </h1>
          <p className="max-w-xl mx-auto text-sm font-light tracking-widest text-black/60 leading-relaxed uppercase" data-id="element-273">
            Discover our curated selection of {title}. High-fashion
            craftsmanship meets cultural heritage.
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8" data-id="element-274">
          {collectionImages.map((img, i) => <div key={i} className="group cursor-pointer" data-id="element-275">
              <div className="aspect-[3/4] bg-grey-divider overflow-hidden mb-4 relative" data-id="element-276">
                <img src={img} alt={`Product ${i + 1}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-277" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors" data-id="element-278" />
              </div>
              <h3 className="text-[11px] font-display font-bold tracking-widest uppercase mb-1" data-id="element-279">
                {title} Piece {String(i + 1).padStart(2, '0')}
              </h3>
              <p className="text-xs font-light text-black/50" data-id="element-280">$240.00</p>
            </div>)}
        </div>
      </div>
    </div>;
}